import { HookFormFieldWrapperProps } from '../useHookFormFieldWrapper.types';

/**
 * Represents the list of FieldWrapped props for a React Hook Form based form
 * components.
 */
export const hookFormFieldWrapperProps: readonly (keyof HookFormFieldWrapperProps)[] =
  [
    'className',
    'description',
    'disabled',
    'helpIcon',
    'label',
    'noAlert',
    'noLabel',
    'style',
  ];
